
<div  class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
            <div class="title ">
                Payment Contracts
                </div>

<div class="payment-contracts-container">
    <p class="subtitle">Manage your payment contracts </p>
  
    <div class="active-contracts">
      <h2>Active Contracts</h2>
      <div class="contract-info">
        <div>
          <!-- <p><strong>Contract ID:</strong> {{userUid}}</p>
          <p class="contract-title">EV Charger Service Agreement</p>
         <p>Signed on January 15, 2024</p> -->
        </div>
        <!-- <img src="assets/ev-charger.jpg" alt="Charger" /> -->
        <button mat-flat-button color="primary" (click)="openPop()">Add Payment Contract</button>

      </div>
    </div>
  
    <div class="payments-section">
      <h3>Upcoming Payments</h3>
      <table mat-table [dataSource]="upcomingPayments" class="mat-elevation-z8">

        <ng-container matColumnDef="contractId">
          <th mat-header-cell *matHeaderCellDef> Contract ID </th>
          <td mat-cell *matCellDef="let element" class="colorblue" (click)="rowClick(element)"> {{element.contractId}} </td>
        </ng-container>
      
        <ng-container matColumnDef="customerId">
          <th mat-header-cell *matHeaderCellDef> Customer ID </th>
          <td mat-cell *matCellDef="let element"> {{element.customerId}} </td>
        </ng-container>
      
        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef> Product </th>
          <td mat-cell *matCellDef="let element"> {{element.product}} </td>
        </ng-container>
      
        <ng-container matColumnDef="supplierPayment">
          <th mat-header-cell *matHeaderCellDef> Supplier Payment </th>
          <td mat-cell *matCellDef="let element"> {{element.supplierPayment}} </td>
        </ng-container>
      
        <ng-container matColumnDef="platformPayment">
          <th mat-header-cell *matHeaderCellDef> Platform Payment </th>
          <td mat-cell *matCellDef="let element"> {{element.platformPayment}} </td>
        </ng-container>
      
        <ng-container matColumnDef="agentPayment">
          <th mat-header-cell *matHeaderCellDef> Agent Payment </th>
          <td mat-cell *matCellDef="let element"> {{element.agentPayment}} </td>
        </ng-container>
      
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element"> {{element.status}} </td>
        </ng-container>
      
        <ng-container matColumnDef="creationTS">
          <th mat-header-cell *matHeaderCellDef> Created On </th>
          <td mat-cell *matCellDef="let element"> {{formatDate(element?.creationTS)}} </td>
        </ng-container>
      
        <ng-container matColumnDef="modTS">
          <th mat-header-cell *matHeaderCellDef> Modified On </th>
          <td mat-cell *matCellDef="let element"> {{formatDate(element?.modTS)}} </td>
        </ng-container>
      
        <ng-container matColumnDef="updatedBy">
          <th mat-header-cell *matHeaderCellDef> Updated By </th>
          <td mat-cell *matCellDef="let element"> {{element.updatedBy}} </td>
        </ng-container>
      
        <ng-container matColumnDef="platformPaymentCharges">
          <th mat-header-cell *matHeaderCellDef> Payment Charges </th>
          <td mat-cell *matCellDef="let element"> {{element.platformPaymentCharges}} </td>
        </ng-container>
      
        <ng-container matColumnDef="paymentChannel">
          <th mat-header-cell *matHeaderCellDef> Payment Channel </th>
          <td mat-cell *matCellDef="let element"> {{element.paymentChannel}} </td>
        </ng-container>
      
        <ng-container matColumnDef="passthroughSuppliers">
          <th mat-header-cell *matHeaderCellDef> Passthrough Suppliers </th>
          <td mat-cell *matCellDef="let element"> {{element.passthroughSuppliers}} </td>
        </ng-container>
      
        <ng-container matColumnDef="paymentModes">
          <th mat-header-cell *matHeaderCellDef> Payment Modes </th>
          <td mat-cell *matCellDef="let element"> {{element.paymentModes}} </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      
    </div>
  
    <div class="payments-section">
      <h3>Payment History</h3>
      <table mat-table [dataSource]="paymentHistory" class="mat-elevation-z1">
  
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let element">{{ element.date }}</td>
        </ng-container>
  
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Amount</th>
          <td mat-cell *matCellDef="let element">{{ element.amount }}</td>
        </ng-container>
  
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            <span class="status-pill paid">{{ element.status }}</span>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
      </table>
    </div>
  
    <div class="button-row">
      <!-- <button mat-button color="primary" class="outline">Contact Support</button>
      <button mat-flat-button color="primary">Manage Payment Methods</button> -->
    </div>
  </div>
  

  <p-dialog 
  [modal]="true"
  [(visible)]="sharePopup" 
  [style]="{ width: '80rem', height: '40rem' }" 
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" 
  [maximizable]="true">
  <ng-template pTemplate="header">
    <h4 *ngIf="action==='new'">Add Payment Contract</h4> 
    <h4 *ngIf="action==='update'">Edit Payment Contracts</h4> 
   </ng-template>
   
  <form [formGroup]="savePaymentFg" class="row mt-4">
   
    
    <mat-form-field class="col-md-6" appearance="outline">
        <mat-label>Product</mat-label>
       
          <mat-select matNativeControl name="product" formControlName="product">
            <mat-option *ngFor="let product of productdata"  [value]="product">{{product}}</mat-option>
          </mat-select>  

      </mat-form-field>
      <mat-form-field class="col-md-6" appearance="outline">
        <mat-label>Platform Payment</mat-label>
  
    
    <mat-select matNativeControl name="platformPayment" formControlName="platformPayment"  >
       
        <mat-option   *ngFor="let item of payModeList" [value]="item">{{item}}</mat-option>
  
        </mat-select>   
    </mat-form-field>
     
        <mat-form-field class="col-md-6" appearance="outline">
            <mat-label>Supplier Payment Medium</mat-label>
      <mat-select matNativeControl name="supplierPayment" (selectionChange)="supplierPaymentChange()" formControlName="supplierPayment"  >
       
        <mat-option   *ngFor="let item of payModeList" [value]="item">{{item}}</mat-option>

        </mat-select>   
      
    </mat-form-field>

    

    <!-- <mat-form-field class="col-md-6" appearance="outline">
        <mat-label>Agent Payment </mat-label>     
      <mat-select matNativeControl name="agentPayment" formControlName="agentPayment"  >
        <mat-option    value="BUSINESS_ISSUED_CARD">BUSINESS_ISSUED_CARD</mat-option>
        <mat-option    value="BUSINESS_OWNED_CARD">BUSINESS_OWNED_CARD</mat-option>

        </mat-select>   
</mat-form-field> -->

    <mat-form-field class="col-md-6" appearance="outline">
      <mat-label>Platform Payment Channels</mat-label>
      <mat-select matNativeControl name="paymentChannel" formControlName="paymentChannel"  >
        <mat-option   *ngFor="let item of payChannelList" [value]="item">{{item}}</mat-option>


        </mat-select>   
    </mat-form-field>
    <mat-form-field class="col-md-6" appearance="outline">
      <mat-label>Supplier Payment Modes</mat-label>
    <mat-select matNativeControl name="paymentModes" formControlName="paymentModes"  >
      <mat-option  *ngFor="let item of paymentChannelList?.paymentChannels" [value]="item">{{item}}</mat-option>
      </mat-select>  
  </mat-form-field>
  <mat-form-field class="col-md-6" appearance="outline">
    <mat-label>Platform Payment Processing Charges </mat-label>     
      <input matInput  (keypress)="onlyNumberKey($event)" name="platformPaymentCharges" formControlName="platformPaymentCharges" />
    </mat-form-field>
    <!-- <mat-form-field class="col-md-6" appearance="outline">
        <mat-label>Passthrough Suppliers</mat-label>
      <input matInput name="passthroughSuppliers" formControlName="passthroughSuppliers" />
    </mat-form-field> -->

    
   
  </form>

  <ng-template pTemplate="footer">
    <button *ngIf="action==='new'" mat-flat-button color="primary" (click)="onSavePayment('new')" [disabled]="savePaymentFg.invalid||disabled">Save</button>
    <button *ngIf="action==='update'" mat-flat-button color="primary" (click)="onSavePayment('update')" [disabled]="savePaymentFg.invalid||disabled">Update</button>

  </ng-template>
</p-dialog>
